"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_DATA_ATTRIBUTE = exports.THEMES = exports.DEFAULT_THEME = void 0;
var THEMES = exports.THEMES = ['light', 'dark'];
var DEFAULT_THEME = exports.DEFAULT_THEME = 'light';
var THEME_DATA_ATTRIBUTE = exports.THEME_DATA_ATTRIBUTE = 'data-theme';